import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { trackBookingClick } from './tracking/newbuildingBooking';
import { openNewbuildingBookedFromDeveloperConfirmAction } from '../../actions/newbuildingBookedFromDeveloper';
import { NewbuildingBookedFromDeveloperButton } from '../../components/NewbuildingBookedFromDeveloperButton';
import { getOfferCustomUrl } from '../../selectors/analytics';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const NewbuildingBookedFromDeveloperButtonContainer = ({ contactsButton }: { contactsButton: any }) => {
  const dispatch = useDispatch();
  const customUrl = useSelector(getOfferCustomUrl);

  const bookOffer = React.useCallback(() => {
    dispatch(openNewbuildingBookedFromDeveloperConfirmAction());
    trackBookingClick(customUrl);
  }, [dispatch, customUrl]);

  return <NewbuildingBookedFromDeveloperButton onClick={bookOffer} contactsButton={contactsButton} />;
};
